import { useOnlineStatus } from '../hooks/useOnlineStatus';

export function ConnectivityBanner() {
  const isOnline = useOnlineStatus();
  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="connectivity-banner"
    >
      You&apos;re offline - bills will sync when connected
    </div>
  );
}
